module.exports = __webpack_public_path__ + "img/js_logo_web.275fac6b.png";